<template>
  <div class="comment-page">
    <!-- 页面头部 -->
    <div class="page-header">
      <div>
        <div class="page-title">评论管理</div>
        <div class="page-desc">查看和管理用户评论，及时回复用户反馈</div>
      </div>
    </div>

    <!-- 搜索区域 -->
    <el-card class="search-card" shadow="never">
      <el-form
        :inline="true"
        :model="searchForm"
        class="search-form"
      >
        <el-form-item>
          <el-input
            v-model="searchForm.keyword"
            placeholder="请输入用户昵称或评论内容"
            clearable
            prefix-icon="el-icon-search"
            style="width: 280px"
          />
        </el-form-item>

        <el-form-item>
          <el-select
            v-model="searchForm.status"
            placeholder="评论状态"
            clearable
            style="width: 140px"
          >
            <el-option label="全部" value="" />
            <el-option label="待回复" value="0" />
            <el-option label="已回复" value="1" />
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search">
            查询
          </el-button>

          <el-button icon="el-icon-refresh">
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 列表 -->
    <el-card class="table-card" shadow="never">
      <div class="table-header">
        <div class="table-title">评论列表</div>
        <div class="table-total">
          共 {{ total }} 条评论
        </div>
      </div>

      <el-table
        :data="tableData"
        v-loading="loading"
        border
        class="comment-table"
      >
        <!-- 用户 -->
        <el-table-column label="用户" width="180">
          <template slot-scope="{ row }">
            <div class="user-info">
              <el-avatar
                :size="38"
                :src="row.avatar"
              >
                {{ row.nickname ? row.nickname.charAt(0) : 'U' }}
              </el-avatar>

              <div class="user-detail">
                <div class="user-name">
                  {{ row.nickname }}
                </div>
                <div class="user-id">
                  ID：{{ row.userId }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>

        <!-- 评论内容 -->
        <el-table-column
          label="评论内容"
          min-width="380"
        >
          <template slot-scope="{ row }">
            <div class="comment-content">
              <div class="comment-text">
                {{ row.content }}
              </div>

              <div class="comment-source">
                所属内容：
                <span>{{ row.sourceTitle }}</span>
              </div>

              <div
                v-if="row.replyContent"
                class="reply-preview"
              >
                <span class="reply-label">管理员回复：</span>
                {{ row.replyContent }}
              </div>
            </div>
          </template>
        </el-table-column>

        <!-- 时间 -->
        <el-table-column
          label="评论时间"
          width="170"
          prop="createTime"
        />

        <!-- 状态 -->
        <el-table-column
          label="状态"
          width="100"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.replyContent"
              type="success"
              size="small"
            >
              已回复
            </el-tag>

            <el-tag
              v-else
              type="warning"
              size="small"
            >
              待回复
            </el-tag>
          </template>
        </el-table-column>

        <!-- 操作 -->
        <el-table-column
          label="操作"
          width="130"
          align="center"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-button
              v-if="!row.replyContent"
              type="text"
              size="small"
              @click="handleReply(row)"
            >
              回复
            </el-button>

            <el-button
              v-else
              type="text"
              size="small"
              @click="handleReply(row)"
            >
              查看回复
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-size="searchForm.pageSize"
          :current-page="searchForm.pageNum"
        />
      </div>
    </el-card>

    <!-- 回复弹窗 -->
    <el-dialog
      title="回复评论"
      :visible.sync="replyDialogVisible"
      width="560px"
      custom-class="reply-dialog"
      @close="resetReply"
    >
      <div v-if="currentComment" class="reply-dialog-content">
        <!-- 用户信息 -->
        <div class="dialog-user">
          <el-avatar
            :size="42"
            :src="currentComment.avatar"
          >
            {{ currentComment.nickname.charAt(0) }}
          </el-avatar>

          <div>
            <div class="dialog-user-name">
              {{ currentComment.nickname }}
            </div>
            <div class="dialog-time">
              {{ currentComment.createTime }}
            </div>
          </div>
        </div>

        <!-- 原评论 -->
        <div class="original-comment">
          <div class="section-label">用户评论</div>
          <div class="original-content">
            {{ currentComment.content }}
          </div>
        </div>

        <!-- 回复输入 -->
        <el-form
          ref="replyForm"
          :model="replyForm"
          :rules="replyRules"
        >
          <el-form-item
            label="回复内容"
            prop="content"
          >
            <el-input
              v-model="replyForm.content"
              type="textarea"
              :rows="5"
              maxlength="500"
              show-word-limit
              placeholder="请输入回复内容"
            />
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer">
        <el-button @click="replyDialogVisible = false">
          取消
        </el-button>

        <el-button
          type="primary"
          :loading="replyLoading"
          @click="submitReply"
        >
          提交回复
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'CommentManage',

  data() {
    return {
      loading: false,
      replyLoading: false,

      total: 2,

      searchForm: {
        keyword: '',
        status: '',
        pageNum: 1,
        pageSize: 10
      },

      tableData: [
        {
          id: 1,
          userId: 10001,
          nickname: '小明',
          avatar: '',
          content: '这个功能非常实用，体验很好，希望后续继续优化。',
          sourceTitle: '系统使用帮助',
          createTime: '2026-09-18 10:20:30',
          replyContent: ''
        },
        {
          id: 2,
          userId: 10002,
          nickname: '小红',
          avatar: '',
          content: '希望后续可以增加导出功能。',
          sourceTitle: '数据管理说明',
          createTime: '2026-09-17 15:12:20',
          replyContent: '感谢您的建议，我们会认真评估该功能。'
        }
      ],

      replyDialogVisible: false,

      currentComment: null,

      replyForm: {
        content: ''
      },

      replyRules: {
        content: [
          {
            required: true,
            message: '请输入回复内容',
            trigger: 'blur'
          }
        ]
      }
    }
  },

  methods: {
    handleReply(row) {
      this.currentComment = row

      this.replyForm.content = row.replyContent || ''

      this.replyDialogVisible = true
    },

    resetReply() {
      this.currentComment = null
      this.replyForm.content = ''

      if (this.$refs.replyForm) {
        this.$refs.replyForm.resetFields()
      }
    },

    submitReply() {
      this.$refs.replyForm.validate(valid => {
        if (!valid) return

        this.replyLoading = true

        // 调用回复接口
        setTimeout(() => {
          this.$message.success('回复成功')

          this.replyLoading = false
          this.replyDialogVisible = false
        }, 500)
      })
    }
  }
}
</script>
<style scoped>
.comment-page {
  min-height: 100%;
  padding: 24px;
  background: #f5f7fa;
}

/* 页面头部 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-title {
  font-size: 22px;
  font-weight: 600;
  color: #303133;
  line-height: 32px;
}

.page-desc {
  margin-top: 6px;
  font-size: 13px;
  color: #909399;
}

/* 搜索卡片 */
.search-card {
  margin-bottom: 16px;
  border-radius: 6px;
}

.search-form {
  margin-bottom: -18px;
}

/* 表格卡片 */
.table-card {
  border-radius: 6px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}

.table-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.table-total {
  font-size: 13px;
  color: #909399;
}

/* 用户信息 */
.user-info {
  display: flex;
  align-items: center;
}

.user-detail {
  margin-left: 10px;
}

.user-name {
  font-size: 14px;
  color: #303133;
  margin-bottom: 5px;
}

.user-id {
  font-size: 12px;
  color: #a8abb2;
}

/* 评论内容 */
.comment-content {
  padding: 4px 0;
}

.comment-text {
  color: #303133;
  line-height: 22px;
  font-size: 14px;
}

.comment-source {
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
}

.comment-source span {
  color: #409eff;
}

/* 回复预览 */
.reply-preview {
  margin-top: 10px;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 4px;
  color: #606266;
  font-size: 12px;
  line-height: 20px;
}

.reply-label {
  color: #67c23a;
  font-weight: 500;
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

/* 弹窗 */
.reply-dialog-content {
  padding: 0 4px;
}

.dialog-user {
  display: flex;
  align-items: center;
  margin-bottom: 22px;
}

.dialog-user-name {
  margin-left: 12px;
  font-size: 15px;
  color: #303133;
  font-weight: 500;
}

.dialog-time {
  margin-left: 12px;
  margin-top: 5px;
  color: #909399;
  font-size: 12px;
}

.original-comment {
  margin-bottom: 22px;
}

.section-label {
  margin-bottom: 10px;
  font-size: 14px;
  color: #303133;
  font-weight: 500;
}

.original-content {
  padding: 14px 16px;
  background: #f5f7fa;
  border-radius: 5px;
  color: #606266;
  line-height: 24px;
  font-size: 14px;
}
</style>